import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import CloudUploadOutlinedIcon from "@mui/icons-material/CloudUploadOutlined";
import { styled } from "@mui/material/styles";
import FormData from "form-data";
import axios from "axios";
import toast from "react-simple-toasts";
import ImageFilePicker from "../inputs/ImageFilePicker";
import { useState } from "react";
import Checkbox from "@mui/material/Checkbox";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Typography from "@mui/material/Typography";
import FormPaper from "../FormPaper";

// Hidden input for file upload, styled to be visually hidden but still accessible
const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

function Add({ setProducts }) {
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [imageFile, setImageFile] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [isAvailable, setIsAvailable] = useState(true);
  const [hidden, setHidden] = useState(false);
  const [price, setPrice] = useState(null);
  const [priceUnit, setPriceUnit] = useState("");
  const [disabled, setDisabled] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setDisabled(true); // Disable the submit button to prevent multiple submissions

    // Create a FormData object to send the product data, including the image file
    const formData = new FormData();
    formData.append("productName", name);
    formData.append("productDescription", description);
    formData.append("productImage", imageFile, imageFile.name);
    formData.append("productIsAvailable", isAvailable ? 1 : 0);
    formData.append("productHidden", hidden ? 1 : 0);
    formData.append("productPrice", price);
    formData.append("productPriceUnit", priceUnit);

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/products/add`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );

      // Update the products list in the parent component with the newly added product
      const newProduct = {
        productId: res.data.productId,
        productName: name,
        productDescription: description,
        productImageURL: res.data.productImageURL,
        productImagePublicId: res.data.productImagePublicId,
        productIsAvailable: isAvailable,
        productHidden: hidden,
        productPrice: price,
        productPriceUnit: priceUnit,
      };
      setProducts((prevProducts) => [...prevProducts, newProduct]);

      toast(res.data.message, { theme: "success" });

      // Reset the form fields and state after successful submission
      setDisabled(false);
      setName("");
      setDescription("");
      setImageFile(null);
      setImagePreview(null);
      setIsAvailable(true);
      setHidden(false);
      setPrice(0.0);
      setPriceUnit("");
    } catch (err) {
      console.error(err);
      toast("Erreur lors de l'ajout du produit.", { theme: "failure" });
      setDisabled(false);
    }
  };

  return (
    <FormPaper>
      <form id="addForm" onSubmit={handleSubmit}>
        <Stack direction="column" spacing={2}>
          <TextField
            id="name"
            name="name"
            label="Nom"
            placeholder="Oeufs"
            value={name}
            required
            onChange={(e) => setName(e.target.value)}
          />
          <TextField
            multiline
            minRows={2}
            id="description"
            name="description"
            label="Description"
            placeholder="Oeufs de poule bio"
            value={description}
            required
            onChange={(e) => setDescription(e.target.value)}
          />
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  checked={isAvailable}
                  onChange={(e) => setIsAvailable(e.target.checked)}
                />
              }
              label="Disponible"
            />
          </FormGroup>
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  checked={hidden}
                  onChange={(e) => setHidden(e.target.checked)}
                />
              }
              label="Désactivé"
            />
          </FormGroup>
          <Stack direction="row" spacing={2} sx={{ alignItems: "center" }}>
            <TextField
              id="price"
              name="price"
              label="Prix"
              type="number"
              placeholder="2.50"
              value={price}
              required
              slotProps={{
                htmlInput: {
                  min: 0,
                  step: 0.01,
                },
              }}
              onChange={(e) => setPrice(e.target.value)}
            />
            <Typography variant="h3">/</Typography>
            <TextField
              id="priceUnit"
              name="priceUnit"
              label="Unité"
              placeholder="Unité"
              value={priceUnit}
              required
              onChange={(e) => setPriceUnit(e.target.value)}
            />
          </Stack>
          <ImageFilePicker
            setImageFile={setImageFile}
            setImagePreview={setImagePreview}
          />
          {imagePreview && (
            <img
              src={imagePreview}
              alt="Preview"
              style={{
                width: 250,
                borderRadius: 8,
              }}
            />
          )}
          <Button
            variant="contained"
            color="primary"
            type="submit"
            disabled={disabled}
          >
            Ajouter
          </Button>
        </Stack>
      </form>
    </FormPaper>
  );
}

export default Add;
